import { useLayout } from "@/contexts/LayoutContext";

export const useApiKeyRequestMailto = () => {
  const { data: layoutData } = useLayout();
  const subject = `klipboard CRM - Requesting an API key (Account ${layoutData.account})`;
  const body = `Hi, I'm ${layoutData.username} and I would like to request an API key for account ${layoutData.account} so I can get more information about the records linked to my webhook messages. Please let me know the next steps.`;

  return `mailto:jayne.hill@klipboard.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
